<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"goodsType": "Goods Type",
		"name": "Name",
		"code": "Code",
		"alternativeName": "Alternative Name",
		"minTemperature": "Min. temp.",
		"maxTemperature": "Max temp."
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"goodsType": "Godstype",
		"name": "Navn",
		"code": "Kode",
		"alternativeName": "Alternativt navn",
		"minTemperature": "Min. temp.",
		"maxTemperature": "Maks temp."
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header :icon="getGoodsTypeIcon(data.iconId)" :text="$t('goodsType')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('name')"
						:value="data.name"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('code')"
						:value="data.tpxCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('alternativeName')"
						:value="data.alternativeName"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('minTemperature')"
						:value="temperatureFormat(data.minTemperature)"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('maxTemperature')"
						:value="temperatureFormat(data.maxTemperature)"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
import { goodsTypesIcons } from '@/core';

export default {
	name: 'GoodsType',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	},
	methods: {
		getGoodsTypeIcon(iconId) {
			return goodsTypesIcons.getById(iconId);
		},
		temperatureFormat(temp) {
			return temp ? `${Math.floor(temp)} \u2103` : 'N/A';
		}
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: minmax(150px, 1fr);
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>